import axiosInstance from './AxiosInstance';

/**
 * Obtiene el perfil completo de la empresa autenticada
 * GET /perfil-empresa
 */
export function getCompanyProfile() {
    return axiosInstance.get('/perfil-empresa');
}

/**
 * Actualiza el perfil completo de la empresa
 * PUT /perfil-empresa
 * @param {Object} profileData - Datos completos del perfil
 */
export function updateCompanyProfile(profileData) {
    return axiosInstance.put('/perfil-empresa', profileData);
}

/**
 * Actualiza campos específicos del perfil de la empresa
 * PATCH /perfil-empresa
 * @param {Object} profileData - Datos parciales del perfil a actualizar
 */
export function patchCompanyProfile(profileData) {
    return axiosInstance.patch('/perfil-empresa', profileData);
}

/**
 * Actualiza la foto de perfil de la empresa
 * POST /perfil-empresa/foto-perfil
 * @param {File} file - Archivo de imagen
 */
export function updateCompanyProfilePicture(file) {
    const formData = new FormData();
    formData.append('file', file);
    return axiosInstance.post('/perfil-empresa/foto-perfil', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
}       